export const toObjectAsync = async (source, selector) => {
    const map = {};
    for await (const value of source) {
        map[await selector(value)] = value;
    }
    return map;
};
